export default {
  data() {
    return {
      emotionList: [], //情感交流列表
    }
  },
  created() {
    this.getEmotionList()
  },
  methods: {
    //去情感交流详情
    goEmotionMessage(id) {
      this.$router.push({ path: '/emotionMessage', query: { id } })
    },
    //获取情感交流列表
    getEmotionList() {
      this.$axios
        .post('/api/index/newsList', {
          type: 2,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.emotionList = res.data.data.newsList
          } else {
            this.emotionList = []
          }
        })
    },
  },
}
